import { Box } from '@material-ui/core';
import styled from 'styled-components';

export const StatisticsViewContainer = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 0;
`;

export const StyledHeader = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 35px;
`;

export const StyledIncidentCount = styled.span`
    margin: 0 5px 0px 8px;
`;

export const StyledCategory = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const StyledHDXButtonContainer = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: ${({ theme }) => theme.spacing(3)}px;
`;

export const StyledBottom = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: ${({ theme }) => theme.spacing(2)}px;
    overflow-x: auto;
    overflow-y: scroll;
`;
